import { render, staticRenderFns } from "./awardCard.vue?vue&type=template&id=3ad088bc&scoped=true&"
import script from "./awardCard.vue?vue&type=script&lang=js&"
export * from "./awardCard.vue?vue&type=script&lang=js&"
import style0 from "./awardCard.vue?vue&type=style&index=0&id=3ad088bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad088bc",
  null
  
)

export default component.exports